import type { GetQueryArgsType } from '../../../types';
import { APP_API_TAGS } from '../../app.constants';
import { appService } from '../../services/app-service';
import type {
  AllIndustryParams,
  GetIndustriesResponse,
  GetPlansResponse,
} from './onboarding.type';

const { PLANS, INDUSTRIES } = APP_API_TAGS || {};

export const onboardingApi = appService.injectEndpoints({
  endpoints: (builder) => ({
    getAllPlans: builder.query<
      GetPlansResponse,
      GetQueryArgsType<{ is_monthly?: boolean; is_yearly?: boolean }>
    >({
      query: (queryArgs) => ({
        url: '/hrx/plans',
        method: 'GET',
        ...queryArgs,
      }),
      providesTags: [PLANS],
    }),
    getAllIndustries: builder.query<
      GetIndustriesResponse,
      GetQueryArgsType<AllIndustryParams>
    >({
      query: (queryArgs) => ({
        url: '/hrx/industries',
        method: 'GET',
        ...queryArgs,
      }),
      providesTags: [INDUSTRIES],
    }),
  }),
});

// Export onboarding API hooks
export const {
  // Plan Management
  useGetAllPlansQuery,
  useGetAllIndustriesQuery,
} = onboardingApi;
